export default "__VITE_ASSET__Bp6YGzLf__"